import { useContext, useMemo } from 'react'

import { TopSectionPropsContext } from 'Pods/ItemPage/TopSection/context/TopSectionPropsContext'
import i18n from 'Pods/Shared/I18n'

const KEY_PREFIX = 'useCases'

// The i18next singleton stays on 'en', so every call names the page locale explicitly.
export const createUseCaseTranslator = (locale = 'en', is3dPrintModel = false) => {
  const t = (key, options) => i18n.t(`${KEY_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options })
  const variant = is3dPrintModel ? 'make' : 'useCase'
  const tv = (key, options) => t(`${key}.${variant}`, options)

  return { t, tv, locale }
}

export const defaultUseCaseTranslator = createUseCaseTranslator()

// Stable per locale and model type, so it is safe in hook dependency lists.
export default function useUseCaseTranslate() {
  const context = useContext(TopSectionPropsContext)
  const locale = context?.locale || 'en'
  const is3dPrintModel = Boolean(context?.is3dPrintModel)

  return useMemo(() => createUseCaseTranslator(locale, is3dPrintModel), [locale, is3dPrintModel])
}
